module.exports = __webpack_public_path__ + "img/1492494108.8a195e42.jpg";